(() => {
  if (window.ampLocalizationReady) return;
  window.ampLocalizationReady = true;
  const configNode = document.getElementById('AmpMarketConfig');
  const form = document.getElementById('AmpCountryForm');
  const dialog = document.getElementById('AmpCountryDialog');
  if (!configNode || !form || !dialog) return;
  const config = JSON.parse(configNode.textContent);
  const select = form.querySelector('[name="country_code"]');
  const banner = document.getElementById('AmpMarketSuggestion');
  const cookie = name => document.cookie.split('; ').find(item => item.startsWith(`${name}=`))?.split('=')[1];
  const saveCookie = (name, value, seconds = 31536000) => {
    document.cookie = `${name}=${value}; Max-Age=${seconds}; Path=/; SameSite=Lax; Secure`;
  };
  let manualAction = 0;
  const remember = country => {
    if (!config.countries.includes(country)) return;
    manualAction++;
    saveCookie('amp_country_choice', country);
    // Manual choice wins over future IP/VPN detection.
  };
  const destination = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    url.searchParams.delete('language');
    return url.pathname + url.search + url.hash;
  };
  const updateCountry = (country, manual) => {
    if (!config.countries.includes(country)) return;
    if (manual) remember(country);
    select.value = country;
    form.querySelector('[name="return_to"]').value = destination();
    HTMLFormElement.prototype.submit.call(form);
  };
  let opener;
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-amp-market-open]');
    if (open) {
      opener = open;
      select.value = config.country;
      dialog.showModal();
    }
    if (event.target.closest('[data-amp-market-close]')) dialog.close();
    const option = event.target.closest('localization-form [data-value]');
    if (option && option.closest('localization-form').querySelector('[name="country_code"]')) remember(option.dataset.value);
  });
  dialog.addEventListener('close', () => opener?.focus());
  document.addEventListener('submit', event => {
    const countryField = event.target.querySelector('[name="country_code"]');
    if (countryField) remember(countryField.value);
    if (event.target === form) form.querySelector('[name="return_to"]').value = destination();
  }, true);
  if (config.designMode || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
  const explicitCountry = new URL(window.location.href).searchParams.get('country')?.toUpperCase();
  if (explicitCountry && config.countries.includes(explicitCountry)) remember(explicitCountry);
  let busy = false;
  let switching = false;
  let lastCheck = 0;
  const root = window.Shopify?.routes?.root || '/';
  const offerCountry = target => {
    const option = [...select.options].find(item => item.value === target.handle);
    if (!option || !banner) return;
    banner.querySelector('[data-amp-market-message]').textContent = config.recommendation.replace('__country__', option.dataset.name);
    const switchButton = banner.querySelector('[data-amp-market-switch]');
    switchButton.textContent = config.switchLabel.replace('__country__', option.dataset.name).replace('__currency__', option.dataset.currency);
    switchButton.onclick = () => updateCountry(target.handle, true);
    banner.querySelector('[data-amp-market-stay]').onclick = () => {
      remember(config.country);
      banner.hidden = true;
    };
    banner.hidden = false;
  };
  const detectCountry = async () => {
    if (busy || switching || document.visibilityState === 'hidden') return;
    if (lastCheck && Date.now() - lastCheck < 5000) return;
    busy = true;
    lastCheck = Date.now();
    const startedAfterManualAction = manualAction;
    try {
      const url = new URL(`${root}browsing_context_suggestions.json`, window.location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('country[exclude]', config.country);
      url.searchParams.set('_amp_location_check', String(Date.now()));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(4000) });
      if (!response.ok) throw new Error('Country lookup failed');
      const data = await response.json();
      const detected = data.detected_values?.country;
      const suggestion = data.suggestions?.find(item => config.countries.includes(item.parts?.country?.handle));
      const target = config.countries.includes(detected?.handle)
        ? detected
        : suggestion?.parts?.country;
      if (!target?.handle) return;
      saveCookie('amp_detected_country', target.handle);
      if (!config.countries.includes(target.handle)) {
        if (banner) banner.hidden = true;
        return;
      }
      if (manualAction !== startedAfterManualAction) return;
      const choice = cookie('amp_country_choice');
      if (config.countries.includes(choice)) {
        if (banner) banner.hidden = true;
        return;
      }
      if (target.handle === config.country) {
        saveCookie('amp_auto_redirect', '', 0);
        if (banner) banner.hidden = true;
        return;
      }
      const confidence = Number(target.confidence ?? suggestion?.parts?.country?.confidence ?? suggestion?.confidence ?? 0);
      if (!detected?.handle && confidence < 0.9) {
        offerCountry(target);
        return;
      }
      const previous = (cookie('amp_auto_redirect') || '').split(':');
      if (previous[0] === target.handle && Date.now() - Number(previous[1]) < 120000) {
        offerCountry(target);
        return;
      }
      const guard = `${target.handle}:${Date.now()}`;
      saveCookie('amp_auto_redirect', guard, 120);
      if (cookie('amp_auto_redirect') !== guard) {
        offerCountry(target);
        return;
      }
      switching = true;
      updateCountry(target.handle, false);
    } catch {
      lastCheck = 0;
    } finally {
      busy = false;
    }
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') detectCountry();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) detectCountry();
  });
  // Detect on each page entry without periodically changing cart currency.
  detectCountry();
})();
